"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Note = exports.NoteEntityType = exports.NoteImportance = void 0;
var cerealParse_1 = require("../cerealParse");
var NoteImportance;
(function (NoteImportance) {
    NoteImportance[NoteImportance["low"] = 0] = "low";
    NoteImportance[NoteImportance["high"] = 1] = "high";
})(NoteImportance = exports.NoteImportance || (exports.NoteImportance = {}));
var NoteEntityType;
(function (NoteEntityType) {
    NoteEntityType[NoteEntityType["clients"] = 0] = "clients";
    NoteEntityType[NoteEntityType["agencies"] = 1] = "agencies";
    NoteEntityType[NoteEntityType["scus"] = 2] = "scus";
    NoteEntityType[NoteEntityType["signups"] = 3] = "signups";
})(NoteEntityType = exports.NoteEntityType || (exports.NoteEntityType = {}));
var Note = /** @class */ (function () {
    function Note(id, ts, importance, creator, message) {
        this.id = id;
        this.ts = ts;
        this.importance = importance;
        this.creator = creator;
        this.message = message;
    }
    Note.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Note(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'ts'), cerealParse_1.ParseUtils.getEnum(o, 'importance', NoteImportance), cerealParse_1.ParseUtils.getString(o, 'creator'), cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Note Model: " + e.message);
        }
    };
    Note.importanceColor = function (importance) {
        switch (importance) {
            case NoteImportance.high:
                return '#db2828';
            case NoteImportance.low:
                return '#8f8f8f';
        }
    };
    return Note;
}());
exports.Note = Note;
//# sourceMappingURL=note.js.map